module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e1"
    }
  }, [_vm._v("Introduction ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e8078"
    }
  }, [_vm._v("With worldwide diagnoses of autism increasing dramatically over the past decade, you are one of many parents looking for answers about this and other disorders on the autism disorder spectrum.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e8258"
    }
  }, [_vm._v("You may be one of the parents who saw your beautiful baby begin talking, expressing his happiness and interest in the world around him, only to see him begin to regress and retreat into a world that seemed all his own. After watching this transformation in your child, it may come as a relief to finally have a diagnosis of autism so you can begin to help your child—by finding ways to help him communicate and interact with those around him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e8578"
    }
  }, [_vm._v("You are already taking the first steps toward helping your child with autism to become the best person he can be. By reading this book, you are seeking out information about autism, wanting to know more about its symptoms, potential causes, treatment options, and available resources for your family. The study of autism can raise more questions than answers, but the more information you are armed with, the better prepared you are to be an advocate for your child.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e8959"
    }
  }, [_vm._v("With "), _c('i', [_vm._v("When Your Child Has . . . Autism, ")]), _vm._v("you can learn more about nonverbal communication and about the conceptual thinking that children with autism struggle with. You will learn about tools that can help you to improve your nonverbal communication skills, teach your child to use communication systems like communication boards and picture communication systems, and interpret your child’s behaviors (whether meltdowns or flapping), all of which will help you to draw your child out from his private world and encourage him to explore and discover his own interests.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e9409"
    }
  }, [_vm._v("As a parent, the journey of autism isn’t likely one you anticipated for your child. But it is one that you can travel with your child, experiencing small triumphs, remarkable successes, and a greater appreciation for your family’s strength and the beautiful child you’ve brought into the world.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78fd2352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tilt_ISBN9781598696769_epub_c6_r1.vue
// module id = 72
// module chunks = 0